<template>
  <form class="card-body" @submit.prevent="checkUserStatus()">
    <h2 class="card-login-title">Вход</h2>

    <div class="form-group">
      <label for="input-login-email">E-mail адрес</label>
      <input
        id="input-login-email"
        type="email"
        class="form-control form-control-lg"
        placeholder="E-mail"
        v-model="auth.email"
        name="email"
        v-focus
        ref="input"
      >
    </div>

    <div class="form-actions">
      <button class="btn btn-primary btn-lg btn-block" type="submit">Продолжить</button>
    </div>

    <div class="alert alert-danger" :class="{ 'new': error_new } " v-if="error">{{ error }}</div>
  </form>
</template>

<script>
  import auth from '../../auth'
  import api from '@/api'
  import { pick } from 'lodash'

  export default {
    data () {
      return {
        auth: {
          email: '',
        },
        blocked: false,
        error: '',
        error_new: false,
      }
    },
    computed: {
      authData () {
        return this.auth
      },
    },
    methods: {
      checkUserStatus () {
        if (!this.auth.email) {
          this.$refs.input.focus()
          return
        }

        api.post('auth/status', this.authData)
          .then(({data}) => {
            console.log(data)

            if (data.status === 'active') {
              this.$emit('userActive', this.authData, data)
            }
          })
          .catch((error) => {
            error.response && console.log(error.response)
            this.error = 'Пользователь не найден'

            // Highlight error
            this.error_new = true
            setTimeout(() => {
              this.error_new = false
            }, 100)
          })
      },
      isInputFieldsEmpty () {
        return this.auth.email === ''
      },
    },
  }
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// resources/assets/js/components/login/index.vue